(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 78367:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(82124);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ sendEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23215);



var sendEmail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", fetch("".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/email"), {
                        method: "POST",
                        body: JSON.stringify(data),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEmail(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 48719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13785);
/* harmony import */ var _styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3__);





var Success = function(param) {
    var heading = param.heading, setShowSuccessMessage = param.setShowSuccessMessage, text = param.text, path = param.path;
    // const {heading} = props
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var close = function() {
        setShowSuccessMessage(false);
    };
    var goTo = function() {
        if (path === "") {
            setShowSuccessMessage(false);
            return;
        }
        router.push(path);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().Error),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().icon),
                    onClick: close,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdClose */ .FU5, {
                        fontSize: 20
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/assests/icons/success.png",
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_ErrorAndSuccess_module_css__WEBPACK_IMPORTED_MODULE_3___default().content),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        text,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: goTo,
                                    children: "Continue"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Success);


/***/ }),

/***/ 76809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ localization; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/Helper.js + 1 modules
var Helper = __webpack_require__(68340);
;// CONCATENATED MODULE: ./data/LocalizationData.json
var LocalizationData_namespaceObject = JSON.parse('{"en":{"NotFoundPage":{"Heading":"We could not locate the page you sought.!","subHeading":"To find that page you can do one of the following:","Points":{"one":"Try this search","two":"Use the menu above to navigate to the content.","three":"Use the interactive chatbot below to find the page","four":"Write to us with the subject of information you are seeking."}},"LoginPage":{"Heading":"Login","Points1":{"one":"Bookmark your favourite pages","two":"Easily submit content like news, events","three":"Create and manage your own Shaivite Organization pages"},"Fields":{"email":"Email ID","password":"Password"},"Points2":{"one":"Don\'t have an account?","two":"Sign up","three":"Forgot password?","four":"Click here","five":"Or Continue with"},"Successfull":"Login Successfully Click on Continue to visit"},"SignUpPage":{"Heading":"SignUp","Points1":{"one":"Bookmark your favourite pages","two":"Easily submit content like news, events","three":"Create and manage your own Shaivite Organization pages"},"Fields":{"name":"Name","email":"Email ID","password":"Password","rePassword":"Re-enter Password"},"Points2":{"one":"Already have an account?","two":"Login","three":"Or Sign up with"},"Successfull":"Account created Successfully Please check your email. We are sending you a verification mail to login"},"ForgotPasswordPage":{"Heading":"Forgot Password?","subHeading":"Enter your email ID to recover your password","Fields":{"email":"Email ID"},"Points":{"one":"Don\'t have an account?","two":"Sign up"},"Successfull":"Password updated successfully"},"ResetPasswordPage":{"Heading":"Reset Password","subHeading":"Enter your new password","Fields":{"password":"New Password","rePassword":"Re-enter Password"}},"ChangePasswordPage":{"Heading":"Change Password","subHeading":"Enter your new password","Fields":{"previousPassword":"Enter your Previous Password","password":"Enter your new Password","rePassword":"Re-enter your new Password"},"Successfull":"Password updated successfully"},"ContactPage":{"Heading":"Get in touch with us","subHeading":"Fill in the form with your queries and our team will get in touch with you.","Fields":{"name":"Your name","email":"Your email","subject":"Subject","number":"Phone Number","description":"Description"},"Successfull":"Your query sent successfully"},"ShaiviteInstirutionsPage":{"Heading":"Hindu Shaivite Religious/ Spiritual Service Hub","subHeading":"Create the page for your organization","Fields":{"name":"Contact Name","about":"About the organization","number":"Contact Number","service":"Services Offered","sName":"Organization Name","address":"Location/Address","state":"State","country":"Country"},"Successfull":"Thanks for submitting the information. It will be published after approval"},"NewsPage":{"Heading":"Add News","subHeading":"You can add news items directly to the Shaivam.org News listing now. (They will be published after moderation.)","Fields":{"name":"Name","email":"Email","heading":"News heading","url":"News URL","description":"Brief Description of the News","date":"News Date"},"Successfull":"Thanks for submitting the news item. It will be published after approval"},"MySavedPage":{"Heading":"My Saved Items","subHeading":"You can find here all the items, you have saved across Shaivam.org!","Points":{"one":"Explore","two":"Saved Audios","three":"Saved Articles","four":"Saved News","five":"Saved Pages"}},"EmailSentPage":{"Heading":"Email Sent!","subHeading":"If you have registered already with (EMail) to Shaivam.org, a link to reset your password would be available now in your mailbox."},"ProfilePage":{"Heading":"Profile Settings","subHeading":"Edit your personal details over here","Fields":{"email":"Email ID","password":"Change Password","name":"Name"},"Successfull":"Your profile has been updated successfully"}},"hi":{"NotFoundPage":{"Heading":"हम आपके द्वारा मांगे गए पृष्ठ का पता नहीं लगा सके.!","subHeading":"उस पृष्ठ को खोजने के लिए आप निम्न में से कोई एक कार्य कर सकते हैं:","Points":{"one":"इस खोज का प्रयास करें","two":"पृष्ठ पर नेविगेट करने के लिए उपरोक्त मेनू का उपयोग करें।","three":"पृष्ठ खोजने के लिए नीचे दिए गए इंटरैक्टिव चैटबॉट का उपयोग करें","four":"आप जिस विषय की जानकारी चाह रहे हैं, उसके विषय में हमें लिखें।"}},"LoginPage":{"Heading":"लॉग इन करें","Points1":{"one":"अपने पसंदीदा पृष्ठों को बुकमार्क करें","two":"आसानी से समाचार, ईवेंट जैसी सामग्री सबमिट करें","three":"अपने स्वयं के शैव संगठन पृष्ठ बनाएं और प्रबंधित करें"},"Fields":{"email":"ईमेल आईडी","password":"पासवर्ड"},"Points2":{"one":"खाता नहीं है? ","two":"साइन अप करें","three":"पासवर्ड भूल गए?","four":"यहां क्लिक करें","five":"या इनका प्रयोग करें"},"Successfull":""},"SignUpPage":{"Heading":"साइन अप करें","Points1":{"one":"अपने पसंदीदा पृष्ठों को बुकमार्क करें","two":"आसानी से समाचार, ईवेंट जैसी सामग्री सबमिट करें","three":"अपने स्वयं के शैव संगठन पृष्ठ बनाएं और प्रबंधित करें"},"Fields":{"name":"नाम","email":"ईमेल आईडी","password":"पासवर्ड","rePassword":"पासवर्ड फिर से दर्ज करें"},"Points2":{"one":"पहले से ही एक खाता है?","two":"लॉग इन करें","three":"या इनका प्रयोग करें"},"Successfull":"खाता सफलतापूर्वक बनाया गयाकृपया अपनी ईमेल देखें। हम आपको लॉगिन करने के लिए एक सत्यापन मेल भेज रहे हैं"},"ForgotPasswordPage":{"Heading":"पासवर्ड भूल गए?","subHeading":"अपना पासवर्ड पुनर्प्राप्त करने के लिए अपनी ईमेल आईडी दर्ज करें","Fields":{"email":"ईमेल आईडी"},"Points":{"one":"खाता नहीं है? ","two":"साइन अप करें"},"Successfull":"पासवर्ड सफलतापूर्वक अद्यतन"},"ResetPasswordPage":{"Heading":"पासवर्ड रीसेट","subHeading":"अपना नया पासवर्ड दर्ज करें","Fields":{"password":"पासवर्ड","rePassword":"पासवर्ड फिर से दर्ज करें"}},"ChangePasswordPage":{"Heading":"पासवर्ड बदलें","subHeading":"अपना नया पासवर्ड दर्ज करें","Fields":{"previousPassword":"अपना पिछला पासवर्ड दर्ज करें","password":"अपना नया पासवर्ड दर्ज करें","rePassword":"अपना नया पासवर्ड पुनः दर्ज करें"},"Successfull":"पासवर्ड सफलतापूर्वक अद्यतन"},"ContactPage":{"Heading":"हमारे साथ संपर्क","subHeading":"अपने प्रश्नों के साथ फॉर्म भरें और हमारी टीम आपसे संपर्क करेगी।","Fields":{"name":"नाम","email":"ईमेल","subject":"विषय","number":"फ़ोन नंबर","description":"विवरण"},"Successfull":"आपकी क्वेरी सफलतापूर्वक भेजी गई"},"ShaiviteInstirutionsPage":{"Heading":"शैव धार्मिक/आध्यात्मिक सेवा हब","subHeading":"अपने संगठन के लिए पेज बनाएं","Fields":{"name":"संपर्क नाम","about":"संगठन के बारे में","number":"संपर्क संख्या","service":"सेवाएं","sName":"संगठन का नाम","address":"स्थान का पता","state":"राज्य","country":"देश"},"Successfull":"जानकारी सबमिट करने के लिए धन्यवाद। स्वीकृति के बाद इसे प्रकाशित किया जाएगा।"},"NewsPage":{"Heading":"समाचार जोड़ें","subHeading":"अब आप सीधे Shaivam.org समाचार सूची में समाचार आइटम जोड़ सकते हैं। (उन्हें समीक्षा के बाद प्रकाशित किया जाएगा।)","Fields":{"name":"नाम","email":"ईमेल","heading":"समाचार शीर्षक","url":"समाचार URL","description":"समाचार का संक्षिप्त विवरण","date":"समाचार तिथि"},"Successfull":"समाचार प्रस्तुत करने के लिए धन्यवाद। समीक्षा के बाद इसे प्रकाशित किया जाएगा।"},"MySavedPage":{"Heading":"मेरे सहेजे गए आइटम","subHeading":"Shaivam.org पर आपने जो भी चीज़ें सेव की हैं, आप उन्हें यहाँ पा सकते हैं!","Points":{"one":"खोजना","two":"सहेजे गए ऑडियो","three":"सामग्री","four":"सहेजा गया समाचार","five":"सहेजे गए पृष्ठ"}},"EmailSentPage":{"Heading":"Email Sent!","subHeading":"यदि आप पहले से ही (EMail) के साथ Shaivam.org पर पंजीकृत हैं, तो आपका पासवर्ड रीसेट करने के लिए एक लिंक अब आपके मेलबॉक्स में उपलब्ध होगा।"},"ProfilePage":{"Heading":"पार्श्वचित्र समायोजन","subHeading":"यहां पर अपना व्यक्तिगत विवरण संपादित करें","Fields":{"email":"ईमेल आईडी","password":"पासवर्ड बदलें","name":"नाम"},"Successfull":"आपकी प्रोफ़ाइल सफलतापूर्वक अद्यतन किया गया है"}},"ta":{"NotFoundPage":{"Heading":"நீங்கள் தேடிய பக்கத்தை எங்களால் கண்டுபிடிக்க முடியவில்லை.!","subHeading":"அந்தப் பக்கத்தைக் கண்டுபிடிக்க, பின்வருவனவற்றில் ஒன்றைச் செய்யலாம்:","Points":{"one":"இந்தத் தேடலை முயற்சிக்கவும்","two":"அந்தப் பக்கத்திற்குச் செல்ல மேலே உள்ள மெனுவைப் பயன்படுத்தவும்.","three":"பக்கத்தைக் கண்டறிய கீழே உள்ள ஊடாடும் சாட்போட்டைப் பயன்படுத்தவும்","four":"நீங்கள் தேடும் தகவலைப் பற்றி எங்களுக்கு எழுதுங்கள்."}},"LoginPage":{"Heading":"உள்நுழைய","Points1":{"one":"உங்களுக்கு பிடித்த பக்கங்களை புக்மார்க் செய்யலாம்","two":"செய்திகள், நிகழ்வுகள் போன்றவற்றை எளிதாகச் சமர்ப்பிக்கலாம்","three":"உங்கள் சைவப் பணிக்கான அமைப்பு பக்கங்களை உருவாக்கி நிர்வகிக்கலாம்"},"Fields":{"email":"மின்னஞ்சல் முகவரி","password":"கடவுச்சொல்"},"Points2":{"one":"கணக்கு இல்லையா?","two":"புதிதாகத் தொடங்கவும்","three":"கடவுச்சொல் மறந்துவிட்டதா?","four":"இங்கே கிளிக் செய்யவும்","five":"அல்லது இவற்றைப் பயன்படுத்துங்கள்"},"Successfull":""},"SignUpPage":{"Heading":"புதிதாகத் தொடங்கவும்","Points1":{"one":"உங்களுக்கு பிடித்த பக்கங்களை புக்மார்க் செய்யலாம்","two":"செய்திகள், நிகழ்வுகள் போன்றவற்றை எளிதாகச் சமர்ப்பிக்கலாம்","three":"உங்கள் சைவப் பணிக்கான அமைப்பு பக்கங்களை உருவாக்கி நிர்வகிக்கலாம்"},"Fields":{"name":"பெயர்","email":"மின்னஞ்சல் முகவரி","password":"கடவுச்சொல்","rePassword":"மீண்டும் கடவுச்சொல்"},"Points2":{"one":"ஏற்கனவே ஒரு கணக்கு உள்ளதா?","two":"உள்நுழைக","three":"அல்லது இவற்றைப் பயன்படுத்துங்கள்"},"Successfull":"கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டதுஉங்கள் மின்னஞ்சலைப் பார்க்கவும். உள்நுழைவதற்கான சரிபார்ப்பு மின்னஞ்சலை உங்களுக்கு அனுப்புகிறோம்"},"ForgotPasswordPage":{"Heading":"கடவுச்சொல்லை மறந்துவிட்டீர்களா?","subHeading":"உங்கள் கடவுச்சொல்லை மீட்டெடுக்க உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்","Fields":{"email":"மின்னஞ்சல் முகவரி"},"Points":{"one":"கணக்கு இல்லையா?","two":"புதிதாகத் தொடங்கவும்"},"Successfull":"கடவுச்சொல் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது"},"ResetPasswordPage":{"Heading":"கடவுச்சொல்லை மீட்டமைக்க","subHeading":"உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்","Fields":{"password":"கடவுச்சொல்","rePassword":"மீண்டும் கடவுச்சொல்"}},"ChangePasswordPage":{"Heading":"கடவுச்சொல்லை மாற்று","subHeading":"உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்","Fields":{"previousPassword":"முந்தைய கடவுச்சொல்","password":"புதிய கடவுச்சொல்","rePassword":"புதிய கடவுச்சொல்லை மீண்டும் உள்ளிட"},"Successfull":"கடவுச்சொல் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது"},"ContactPage":{"Heading":"எங்களுடன் தொடர்பு கொள்ள","subHeading":"உங்கள் கேள்விகளுடன் படிவத்தை நிரப்பவும், எங்கள் குழு உங்களைத் தொடர்பு கொள்ளும்.","Fields":{"name":"பெயர்","email":"மின்னஞ்சல்","subject":"பொருள்","number":"தொலைபேசி எண்","description":"விளக்கம்"},"Successfull":"உங்கள் கேள்வி வெற்றிகரமாக அனுப்பப்பட்டது"},"ShaiviteInstirutionsPage":{"Heading":"சைவ சமய /ஆன்மிக சேவை மையம்","subHeading":"உங்கள் அமைப்பின் பக்கத்தை உருவாக்கவும்","Fields":{"name":"தொடர்பு பெயர்","about":"அமைப்பு பற்றி","number":"தொடர்பு எண்","service":"சேவைகள்","sName":"அமைப்பின் பெயர்","address":"இடம்/முகவரி","state":"மாநிலம்","country":"நாடு"},"Successfull":"தகவலைச் சமர்ப்பித்ததற்கு நன்றி. பரிசீலனைக்குப் பிறகு வெளியிடப்படும்"},"NewsPage":{"Heading":"செய்திகளைச் சேர்க்கவும்","subHeading":"நீங்கள் இப்போது Shaivam.org செய்திப் பட்டியலில் நேரடியாகச் செய்திகளைச் சேர்க்கலாம். (அவை மதிப்பாய்வுக்குப் பிறகு வெளியிடப்படும்.)","Fields":{"name":"பெயர்","email":"மின்னஞ்சல்","heading":"செய்தி தலைப்பு","url":"செய்தி URL","description":"செய்தியின் சுருக்கமான விளக்கம்","date":"செய்தி தேதி"},"Successfull":"செய்தியை சமர்ப்பித்ததற்கு நன்றி. பரிசீலனைக்குப் பிறகு வெளியிடப்படும்"},"MySavedPage":{"Heading":"நான் சேமித்த பொருட்கள்","subHeading":"Shaivam.org முழுவதும் நீங்கள் சேமித்துள்ள அனைத்து பொருட்களையும் இங்கே காணலாம்!","Points":{"one":"ஆராயுங்கள்","two":"ஆடியோக்கள்","three":"கட்டுரைகள்","four":"செய்திகள்","five":"பக்கங்கள்"}},"EmailSentPage":{"Heading":"Email Sent!","subHeading":"நீங்கள் ஏற்கனவே (EMail) ஐ Shaivam.org இல் பதிவு செய்திருந்தால், உங்கள் கடவுச்சொல்லை மீட்டமைப்பதற்கான இணைப்பு இப்போது உங்கள் அஞ்சல் பெட்டியில் கிடைக்கும்."},"ProfilePage":{"Heading":"சுயவிவர அமைப்புகள்","subHeading":"உங்கள் தனிப்பட்ட விவரங்களை இங்கே திருத்தவும்","Fields":{"email":" மின்னஞ்சல் முகவரி","password":"கடவுச்சொல்லை மாற்று","name":"பெயர்"},"Successfull":"உங்கள் சுயவிவரம் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது"}}}');
;// CONCATENATED MODULE: ./hooks/useLocalization.js




function localization() {
    var globalselectedlang = (0,es/* useSelector */.v9)(function(state) {
        return state.language.globalLang;
    });
    var ref = (0,react.useState)(""), TextMessage = ref[0], setTextMessage = ref[1];
    // set global selected language
    (0,react.useEffect)(function() {
        var lang = (0,Helper/* handleLang */.z_)();
        var language = JSON.parse(lang);
        if (globalselectedlang == "en" || language == "en") {
            setTextMessage(LocalizationData_namespaceObject.en);
        }
        if (globalselectedlang == "hi" || language == "hi") {
            setTextMessage(LocalizationData_namespaceObject.hi);
        }
        if (globalselectedlang == "ta" || language == "ta") {
            setTextMessage(LocalizationData_namespaceObject.ta);
        }
    }, [
        globalselectedlang
    ]);
    return TextMessage;
}


/***/ }),

/***/ 82124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_contact; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./utils/validations.js
var validations = __webpack_require__(91906);
// EXTERNAL MODULE: ./api/sendEmailApi.js
var sendEmailApi = __webpack_require__(66461);
// EXTERNAL MODULE: ./utils/config.js
var config = __webpack_require__(23215);
;// CONCATENATED MODULE: ./api/contactApi.js



var createContact = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ContactDetails) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log(ContactDetails);
                    return _ctx.abrupt("return", fetch("".concat(config/* Config.BaseUrl */.D.BaseUrl, "/contact-uses"), {
                        method: "POST",
                        body: JSON.stringify({
                            data: ContactDetails
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createContact(ContactDetails) {
        return _ref.apply(this, arguments);
    };
}();
var getContactInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var url;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "".concat(config/* Config.BaseUrl */.D.BaseUrl, "/sub-categories?filters[Sub_category_URL][$eq]=contact-us&populate=*");
                    return _ctx.abrupt("return", fetch(url).then(function(res) {
                        return res.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getContactInfo() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./styles/Contact.module.css
var Contact_module = __webpack_require__(67272);
var Contact_module_default = /*#__PURE__*/__webpack_require__.n(Contact_module);
// EXTERNAL MODULE: ./components/Success.jsx
var Success = __webpack_require__(48719);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/Helper.js + 1 modules
var Helper = __webpack_require__(68340);
// EXTERNAL MODULE: ./hooks/useLocalization.js + 1 modules
var useLocalization = __webpack_require__(76809);
;// CONCATENATED MODULE: ./pages/contact.jsx


















var contact = function(param) {
    var info = param.info;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var router = (0,next_router.useRouter)();
    var url = router.pathname;
    var ref26 = (0,react.useState)({
        email: ""
    }), formHandle = ref26[0], setFormHandle = ref26[1];
    (0,react.useEffect)(function() {
        window.scrollTo(0, 0);
    }, [
        url
    ]);
    var ref27 = (0,react.useState)(false), showSuccessMessage = ref27[0], setShowSuccessMessage = ref27[1];
    var ref28 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            name: "",
            email: "",
            phone: "",
            subject: "",
            description: ""
        }
    }), register = ref28.register, handleSubmit = ref28.handleSubmit, errors = ref28.formState.errors, reset = ref28.reset;
    var ref29 = (0,es.useMutation)(sendEmailApi/* sendEmail */.C, {
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                var Json;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return res.json();
                        case 2:
                            Json = _ctx.sent;
                            if (!(res.status === 200)) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()
    }), emailsend = ref29.mutate;
    var ref30 = (0,es.useMutation)(createContact, {
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                var Json;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return res.json();
                        case 2:
                            Json = _ctx.sent;
                            if (!(res.status === 200)) {
                                _ctx.next = 6;
                                break;
                            }
                            setShowSuccessMessage(true);
                            return _ctx.abrupt("return");
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()
    }), mutate = ref30.mutate, isError = ref30.isError, isLoading = ref30.isLoading;
    var TextMessage = (0,useLocalization/* localization */.Z)();
    var submit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        mutate(data);
                        emailsend({
                            to: data.email,
                            subject: data.subject,
                            html: (0,Helper/* contactEmailFormatter */.yd)(data)
                        });
                        emailsend({
                            to: "shaivam@shaivam.org",
                            cc: data.email,
                            subject: data.subject,
                            html: (0,Helper/* contactEmailFormatter */.yd)(data)
                        });
                        reset({
                            name: "",
                            email: "",
                            phone: "",
                            subject: "",
                            description: ""
                        });
                        setFormHandle((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formHandle), {
                            email: ""
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submit(data, e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: info === null || info === void 0 ? void 0 : (ref = info.attributes) === null || ref === void 0 ? void 0 : ref.Sub_category_Title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: info === null || info === void 0 ? void 0 : (ref1 = info.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.seo) === null || ref2 === void 0 ? void 0 : ref2.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: info === null || info === void 0 ? void 0 : (ref3 = info.attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.seo) === null || ref4 === void 0 ? void 0 : ref4.metaKeywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: info === null || info === void 0 ? void 0 : (ref5 = info.attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.seo) === null || ref6 === void 0 ? void 0 : ref6.metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: info === null || info === void 0 ? void 0 : (ref7 = info.attributes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.seo) === null || ref8 === void 0 ? void 0 : ref8.metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/assests/icons/logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Contact_module_default()).contactWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Contact_module_default()).contactForm,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Contact_module_default()).head,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref9 = TextMessage.ContactPage) === null || ref9 === void 0 ? void 0 : ref9.Heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref10 = TextMessage.ContactPage) === null || ref10 === void 0 ? void 0 : ref10.subHeading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Contact_module_default()).phone,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assests/icons/email.svg",
                                                alt: ""
                                            }),
                                            " ",
                                            "shaivam@shaivam.org"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit(submit),
                            className: (Contact_module_default()).form,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref11 = TextMessage.ContactPage) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Fields) === null || ref12 === void 0 ? void 0 : ref12.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name", {
                                    required: "Please fill the  name",
                                    pattern: {
                                        value: validations/* REGEX.name */.m.name,
                                        message: "Please don't include special characters or numbers"
                                    }
                                })), {
                                    type: "text",
                                    required: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref13 = errors.name) === null || ref13 === void 0 ? void 0 : ref13.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref14 = TextMessage.ContactPage) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.Fields) === null || ref15 === void 0 ? void 0 : ref15.email
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                                    required: "Please enter a Email Address",
                                    pattern: {
                                        value: validations/* REGEX.email */.m.email,
                                        message: "Not a valid Email Address"
                                    }
                                })), {
                                    value: (ref16 = formHandle.email) === null || ref16 === void 0 ? void 0 : ref16.trim(),
                                    onInput: function(e) {
                                        return setFormHandle((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formHandle), {
                                            email: e.target.value
                                        }));
                                    },
                                    type: "text",
                                    required: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref17 = errors.email) === null || ref17 === void 0 ? void 0 : ref17.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref18 = TextMessage.ContactPage) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.Fields) === null || ref19 === void 0 ? void 0 : ref19.number
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("phone", {
                                    required: "Please enter a phone number"
                                })), {
                                    type: "number",
                                    min: 0,
                                    required: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref20 = errors.phone) === null || ref20 === void 0 ? void 0 : ref20.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref21 = TextMessage.ContactPage) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.Fields) === null || ref22 === void 0 ? void 0 : ref22.subject
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("subject", {
                                    required: "Please enter a subject Address"
                                })), {
                                    type: "text",
                                    required: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: TextMessage === null || TextMessage === void 0 ? void 0 : (ref23 = TextMessage.ContactPage) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.Fields) === null || ref24 === void 0 ? void 0 : ref24.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("description", {
                                    required: "Please enter description"
                                })), {
                                    name: "description",
                                    id: "",
                                    cols: "30",
                                    rows: "5"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "btn",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showSuccessMessage === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Success/* default */.Z, {
                heading: "Your Query sent Successfully",
                text: TextMessage === null || TextMessage === void 0 ? void 0 : (ref25 = TextMessage.ContactPage) === null || ref25 === void 0 ? void 0 : ref25.Successfull,
                setShowSuccessMessage: setShowSuccessMessage,
                path: ""
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_contact = (contact);


/***/ }),

/***/ 91906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ REGEX; }
/* harmony export */ });
var REGEX = {
    email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
    number: /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    url: /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
};


/***/ }),

/***/ 67272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactWrapper":"Contact_contactWrapper__2_dX3","contactForm":"Contact_contactForm__AykSW","head":"Contact_head__ddlX6","form":"Contact_form__5n_db","phone":"Contact_phone__v0N_5","phoneDropdown":"Contact_phoneDropdown__ZRXtA","phoneWrapper":"Contact_phoneWrapper__P4hyy","select":"Contact_select__ZJrRa","category":"Contact_category__EUs76"};

/***/ }),

/***/ 13785:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorAndSuccess_wrapper__m6VbB","Error":"ErrorAndSuccess_Error__ViFNn","icon":"ErrorAndSuccess_icon__dRbn2","iconBTN":"ErrorAndSuccess_iconBTN__QIg3l","contentWrapper":"ErrorAndSuccess_contentWrapper__ugjga","content":"ErrorAndSuccess_content__C8hlT","contentError":"ErrorAndSuccess_contentError__RMD6v","img":"ErrorAndSuccess_img__OuVkc"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7536,9774,2888,179], function() { return __webpack_exec__(78367); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);